<template>
  <div class="login-container">
    <Form class="login-form" ref="formCustom" :model="loginForm">
      <h3 class="title">{{$t('Login.system')}}</h3>
      <FormItem prop="passwd">
        <Input type="text" v-model="loginForm.username" :placeholder="$t('Login.username')">
          <Icon type="android-person" slot="prepend"></Icon>
        </Input>
      </FormItem>
      <FormItem prop="passwdCheck">
        <Input type="password" v-model="loginForm.password" :placeholder="$t('Login.password')">
        <Icon type="android-lock" slot="prepend"></Icon>
        </Input>
      </FormItem>
      <FormItem prop="passwdCheck">
        <Input type="text" v-model="loginForm.systemCode" :placeholder="$t('Login.systemCode')">
        <Icon type="ios-world" slot="prepend"></Icon>
        </Input>
      </FormItem>
      <FormItem>
        <Select type="text" @on-change="Changelanguage" :placeholder="$t('Login.language')">
          <Option value="zh-cn" key="zh-cn">{{$t('setting.zhcn')}}</Option>
          <Option value="en-US" key="en-US">{{$t('setting.enUS')}}</Option>
          <Option value="zh-tw" key="zh-tw">{{$t('setting.zhtw')}}</Option>
          <Option value="ja-JP" key="ja-JP">{{$t('setting.jaJP')}}</Option>
          <Option value="vi-VN" key="vi-VN">{{$t('setting.viVN')}}</Option>
          <Option value="th-TH" key="th-TH">{{$t('setting.thTH')}}</Option>
        </Select>
      </FormItem>
      <FormItem>
        <Button type="primary" @click.native.prevent="handleLogin" long>{{$t('Login.login')}}</Button>
      </FormItem>

    </Form>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        loginForm: {
          username: '',
          password: '',
          systemCode: ''
        }
      }
    },
    methods: {
      handleLogin () {
        this.$api.user.login(this.loginForm.username, this.loginForm.password, this.loginForm.systemCode).then(res => {
          localStorage.bearer = res.bearer
          this.$router.push({path: '/'})
        }).catch(error => {
          this.$Message.error(error.errMsg)
        })
      },
      Changelanguage (v) {
        this.$i18n.locale = v
      }
    }
  }
</script>

<style rel="stylesheet/scss" lang="scss">
  @import "src/styles/mixin.scss";
  $bg:#2d3a4b;
  $dark_gray:#889aa4;
  $light_gray:#eee;

  .login-container {
    @include relative;
    height: 100vh;
    background-color: $bg;
    input:-webkit-autofill {
      box-shadow: 0 0 0px 1000px #293444 inset !important;
      -webkit-text-fill-color: #fff !important;
    }
    input {
      background: transparent;
      border: 0px;
      -webkit-appearance: none;
      border-radius: 0px;
      padding: 12px 5px 12px 15px;
      color: $light_gray;
      height: 47px;
    }
    .ivu-select {
      color: $dark_gray;
      vertical-align: middle;
      background-color: transparent;
      border: none;
      font-size: 18px;
    }
    .ivu-select-selection {
      color: $dark_gray;
      vertical-align: middle;
      background-color: transparent;
      border: none;
      font-size: 18px;
    }
    .ivu-select-dropdown {
      color: $dark_gray;
      vertical-align: middle;
      background-color: #2d3a4b;
      border: none;
      font-size: 18px;
    }
    .ivu-select-item {
      color:white;
    }
    .ivu-input-group-prepend {
      padding: 6px 5px 6px 15px;
      color: $dark_gray;
      vertical-align: middle;
      width: 30px;
      background-color: transparent;
      border: none;
      font-size: 18px;
    }
    .title {
      font-size: 26px;
      font-weight: 400;
      color: $light_gray;
      margin: 0px auto 40px auto;
      text-align: center;
      font-weight: bold;
    }
    .login-form {
      position: absolute;
      left: 0;
      right: 0;
      width: 400px;
      padding: 35px 35px 15px 35px;
      margin: 120px auto;
    }
    .ivu-form-item {
      border: 1px solid rgba(255, 255, 255, 0.1);
      background: rgba(0, 0, 0, 0.1);
      border-radius: 5px;
      color: #454545;
    }
  }
</style>



// WEBPACK FOOTER //
// Login.vue?86c64864